// ABOUTME: The six designed theme presets. Each is a curated input to
// ABOUTME: deriveTheme() — the engine still derives every other token.
export interface ThemePreset {
  /** Stable id, and the key into ACCENT_LIGHT / ACCENT_DARK. */
  palette: string;
  label: string;
  background: string;
}

export const THEME_PRESETS: ThemePreset[] = [
  { palette: "chalk", label: "Chalk", background: "#f2f4f1" },
  { palette: "bone", label: "Bone", background: "#edeae3" },
  { palette: "mist", label: "Mist", background: "#e6eaec" },
  { palette: "graphite", label: "Graphite", background: "#15181a" },
  { palette: "moss", label: "Moss", background: "#191d18" },
  { palette: "plum", label: "Plum", background: "#1b1619" },
];
